module.exports = __webpack_public_path__ + "img/symbol_4.585d93f4.png";